export const parseAddressComponents = (
  place: google.maps.places.PlaceResult,
) => {
  const addressComponents = place.address_components || [];
  const addressMap: Record<string, string> = {};

  addressComponents.forEach((component) => {
    const types = component.types;

    if (types.includes('street_number')) {
      addressMap.streetNumber = component.long_name;
    }
    if (types.includes('route')) {
      addressMap.route = component.long_name;
    }
    if (types.includes('locality')) {
      addressMap.city = component.long_name;
    }
    if (types.includes('administrative_area_level_1')) {
      addressMap.state = component.long_name;
    }
    if (types.includes('postal_code')) {
      addressMap.postalCode = component.long_name;
    }
    if (types.includes('country')) {
      addressMap.country = component.long_name;
      addressMap.countryCode = component.short_name;
    }
  });

  return {
    streetLine1:
      `${addressMap.streetNumber || ''} ${addressMap.route || ''}`.trim(),
    city: addressMap.city || '',
    state: addressMap.state || '',
    postalCode: addressMap.postalCode || '',
    countryCode: addressMap.countryCode || '',
    countryName: addressMap.country || '',
  };
};
